import { createStore } from 'vuex'
import session from './session'
import careplan from './careplan'
import office from './office'
import userlist from './userlist'
import staffShift from './staff_shift'
import createPersistedState from 'vuex-persistedstate'

const store = createStore({
  modules: {
    session,
    careplan,
    office,
    userlist,
    // シフト表(スタッフ)
    staffShift
  },
  plugins: [createPersistedState()]
})

export default store
